module.exports = __webpack_public_path__ + "media/stylesheets/images/media/kurashino_bg-67c85f9b72d41678c58ebf1468dcc267.jpg";